/**
 * Given an account number, returns the last four digits of the
 * account number with a prepended symbol (•• is the default)
 *
 *`
 * maskAccountNumber('123456789') => '••6789'
 * maskAccountNumber('123456789', 'bullets') => '••6789'
 * maskAccountNumber('123456789', 'ellipsis') => '...6789'
 * maskAccountNumber('123456789', 'none') => '6789'
 * `
 */
export function maskAccountNumber(number, symbol) {
    if (symbol === void 0) { symbol = 'bullets'; }
    var lastFour = number.slice(-4);
    switch (symbol) {
        case 'ellipsis':
            return "..." + lastFour;
        case 'none':
            return lastFour;
        case 'bullets':
        default:
            return "\u2022\u2022" + lastFour;
    }
}
//# sourceMappingURL=mask-account-number.js.map